import { Box, Typography } from '@mui/material';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';
import { DialogActions } from 'src/components/molecules/dialog';
import UploadDialog from 'src/components/organisms/upload-dialog';
import { useUploadEmployees } from 'src/features/employees/api/hooks/use-upload-employees';

const UploadEmployeesDialog = ({ open, onCancel }: DialogActions) => {
  const { t } = useTranslation();

  const { mutateAsync: uploadUsers } = useUploadEmployees(onCancel);

  const handleDownloadTemplate = () => {
    saveAs('/static/employees.xlsx', 'employees-template.xlsx');
  };

  return (
    <UploadDialog
      title={t('employees:employees.uploadDialog.title')}
      templateId="employees_download_template_button"
      importId="employees_import_button"
      handleDownload={handleDownloadTemplate}
      open={open}
      onCancel={onCancel}
      onSubmit={file => uploadUsers(file)}
      message={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 2 }}>
          <Typography sx={{ mb: 2 }}>
            {t('employees:employees.uploadDialog.message')}
          </Typography>
        </Box>
      }
    />
  );
};

export default UploadEmployeesDialog;
